/** Site branding */
export const SITE_NAME = 'MaxKeys';
export const SITE_DOMAIN = 'maxkeys.online';
export const SITE_URL = 'https://maxkeys.online';
export const SITE_TAGLINE = 'Genuine Software Keys';

/** Product brand we resell (not our own branding) */
export const BRAND = 'McAfee';

export const SUPPORT_EMAIL = 'support@maxkeys.online';

/** 24/7 sales & technical support line */
export const SUPPORT_PHONE = '1-866-617-2764';
export const SUPPORT_PHONE_TEL = '+18666172764';
export const SUPPORT_HOURS = 'Available 24/7 · Toll-free in the US & Canada';

/** Lead Desk — contact form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_785c29e9684e7c862da23228026c8ae26a410c4a6e91a9b8';

/** Legal operator */
export const COMPANY_NAME = 'Nodex Global LLC';
export const COMPANY_EMAIL = 'info@nodexgloballlc.com';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
/** Single-line form for metadata, schema, and aria labels */
export const ADDRESS = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;

/** Short notice shown in the header top bar */
export const AFFILIATE_DISCLOSURE = `${SITE_NAME} is an independent reseller and is not affiliated with ${BRAND}, LLC.`;

/** Full legal disclaimer, repeated across the site footer and policy pages */
export const FOOTER_DISCLAIMER = [
  `${SITE_NAME} (${SITE_DOMAIN}) is operated by ${COMPANY_NAME}, ${ADDRESS_LINE1} ${ADDRESS_LINE2}. We are an independent reseller of security software and a provider of third-party technical support services. We are not affiliated with, endorsed by, sponsored by, or otherwise connected to ${BRAND}, LLC or any of its subsidiaries or affiliates.`,
  `${BRAND} and the ${BRAND} logo are registered trademarks of ${BRAND}, LLC. All other product names, logos, and brands referenced on this website are the property of their respective owners and are used for identification purposes only, which does not imply endorsement.`,
  'Pricing shown reflects promotional first-term rates and may change without notice. Subscriptions renew at the standard rate unless cancelled before the renewal date. Feature availability varies by plan, platform, and region. Please review our Terms of Service and Refund Policy before completing a purchase.',
];
